import { SphereAvatar } from "@components/header/sphere-avatar";
import { TEAM_AVATAR_BACKGROUND } from "@styles/common-colors";
import { Checkmark2Icon, FontWeights, NO_TRANSLATE_CLASS, TeamIcon, Text } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { withEllipsis } from "@styles/common-styles";
import AutosuggestHighlightMatch from "autosuggest-highlight/match";
import AutosuggestHighlightParse from "autosuggest-highlight/parse";
import { useMemo } from "react";
/** Width for the user avatar */
const AVATAR_WIDTH = "50px";

/** Class name to highlight part of string */
const HIGHLIGHT_CLASS = "text_highlight";
export function UserListItem({
  item,
  disabledMessage,
  inputValue,
  isActive
}) {
  const userItem = {
    ...item,
    type: item.type || "member"
  };
  const highlightedTitle = useMemo(() => {
    /** Early return if there is no input value entered */
    if (!inputValue) {
      return userItem.title;
    }

    // Finding the match parts
    const matches = AutosuggestHighlightMatch(userItem.title, inputValue);
    const parts = AutosuggestHighlightParse(userItem.title, matches);
    return <span>
        {parts.map((part, index) => <span className={part.highlight ? HIGHLIGHT_CLASS : ""} key={index}>
            {part.text}
          </span>)}
      </span>;
  }, [inputValue, userItem.title]);
  const highlightedSubTitle = useMemo(() => {
    /** Early return if there is no input value entered */
    if (!inputValue || !userItem.subtitle) {
      return userItem.subtitle;
    }

    // Finding the match parts
    const matches_0 = AutosuggestHighlightMatch(userItem.subtitle, inputValue);
    const parts_0 = AutosuggestHighlightParse(userItem.subtitle, matches_0);
    return <span>
        {parts_0.map((part_0, index_0) => <span className={part_0.highlight ? HIGHLIGHT_CLASS : ""} key={index_0}>
            {part_0.text}
          </span>)}
      </span>;
  }, [userItem.subtitle, inputValue]);
  return <Box component="div" sx={{
    backgroundColor: isActive ? "action.selected" : "",
    "&:hover": {
      backgroundColor: "surfaces.tertiary",
      cursor: isActive ? "initial" : "pointer"
    },
    display: "flex",
    alignItems: "center",
    padding: "5px 5px",
    width: "100%",
    gap: 1
  }}>
      <Box component="div" sx={{
      display: "flex",
      alignItems: "center",
      width: "100%"
    }}>
        <Box component="div" sx={{
        width: AVATAR_WIDTH
      }}>
          {userItem.type === "team" ? <SphereAvatar icon={<TeamIcon sx={{
          width: "18px",
          height: "18px"
        }} />} size="small" backgroundColor={TEAM_AVATAR_BACKGROUND} /> : <SphereAvatar size={"small"} initials={userItem.userInitials ?? ""} src={userItem.userAvatarImg} shouldUseSimplifiedAvatar={!userItem.isCurrentUser} />}
        </Box>
        <Box component="div" sx={{
        // If there is a disabled message we have two columns, otherwise we have one.
        width: disabledMessage ? `calc(50% - ${AVATAR_WIDTH} / 2)` : `calc(100% - ${AVATAR_WIDTH})`
      }}>
          <Box className={NO_TRANSLATE_CLASS} component="div" sx={{
          width: "100%",
          color: isActive ? "primary.main" : "text.primary",
          fontSize: "14px",
          display: "flex",
          alignItems: "center",
          [`& .${HIGHLIGHT_CLASS}`]: {
            fontWeight: FontWeights.Bold
          }
        }}>
            <Text variant="heading14" component={"var"} sx={{
            flex: 1,
            ...withEllipsis
          }}>
              {highlightedTitle}
            </Text>

            {isActive && <Checkmark2Icon />}
          </Box>

          {userItem.subtitle && <Box className={NO_TRANSLATE_CLASS} component="div" sx={{
          ...withEllipsis,
          width: "100%",
          color: "text.secondary",
          fontSize: "12px",
          [`& .${HIGHLIGHT_CLASS}`]: {
            fontWeight: FontWeights.Bold
          }
        }}>
              {highlightedSubTitle}
            </Box>}
        </Box>
        {disabledMessage && <Box component="div" sx={{
        width: `calc(50% - ${AVATAR_WIDTH} / 2)`,
        color: "text.secondary",
        fontSize: "12px",
        paddingLeft: "20px",
        textAlign: "end"
      }}>
            {disabledMessage}
          </Box>}
      </Box>
    </Box>;
}